<script>
export default {
  name: 'Message',

  props: {
    text: { type: String },
    show: { type: Boolean, default: false }
  },

  data() {
    return {
      autoHideTimer: null
    }
  },

  watch: {
    show(toShow) {
      if (toShow) {
        this.setAutoHide()
      }
    }
  },

  methods: {
    setAutoHide() {
      clearTimeout(this.autoHideTimer)
      this.autoHideTimer = setTimeout(() => {
        clearTimeout(this.autoHideTimer)
        this.$emit('update:show', false)
      }, 4000)
    }
  },

  beforeDestroy() {
    clearTimeout(this.autoHideTimer)
  }
}
</script>

<template lang="pug">
aside.dm-corp-message(:class="{'show': show}")
  .message-inner {{ text }}
</template>

<style lang="scss">
@import '../../styles/variables';

aside.dm-corp-message {
  @include absFullSpread;
  position: fixed;
  z-index: -10;
  pointer-events: none;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  opacity: 0;
  visibility: hidden;

  transition: opacity 0.3s;

  .message-inner {
    padding: 1.5em 3em;
    max-width: 400px;
    color: #fff;
    background: black(0.8);
    border-radius: 8px;
    line-height: 1.3;
  }

  &.show {
    opacity: 1;
    visibility: visible;
    z-index: 1000;
  }
}
</style>
